const middleware = {};
middleware['aff-everflow'] = require('../middleware/aff-everflow.ts');
middleware['aff-everflow'] = middleware['aff-everflow'].default || middleware['aff-everflow'];
middleware['aff-pii-capture'] = require('../middleware/aff-pii-capture.ts');
middleware['aff-pii-capture'] = middleware['aff-pii-capture'].default || middleware['aff-pii-capture'];
middleware['experiment-tagging'] = require('../middleware/experiment-tagging.ts');
middleware['experiment-tagging'] = middleware['experiment-tagging'].default || middleware['experiment-tagging'];
middleware['members-auth'] = require('../middleware/members-auth.ts');
middleware['members-auth'] = middleware['members-auth'].default || middleware['members-auth'];
export default middleware;